import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Base Info", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "album-title" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "主艺人", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = {
  class: "album-name",
  style: {"width":"60%"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-3" }, "艺人", -1)
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "style-list" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" 主要风格 "),
  /*#__PURE__*/_createElementVNode("small", null, "最终提交生效/尽量细化到子风格")
], -1)
const _hoisted_19 = { class: "style-list" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" 相关涉及风格 "),
  /*#__PURE__*/_createElementVNode("small", null, "专辑中出现的其他音乐元素")
], -1)
const _hoisted_21 = { class: "style-list" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "在线试听链接", -1)
const _hoisted_23 = { class: "" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, "封面图", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", null, "请选择封面图，如果列出的抓取照片没有合适的，请直接贴原图链接在输入框", -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "style-list" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", null, "删除本条，将本条信息合并到 ID->", -1)
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "style-list" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h4", null, "拉取discogs/网易/douban数据", -1)
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_EnumEditor = _resolveComponent("EnumEditor")!
  const _component_StyleInput = _resolveComponent("StyleInput")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
    title: _ctx.dialogTitle
  }, {
    footer: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleCombine(2)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 拉取Discog ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleCombine(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 合 并 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.dialogFormVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !_ctx.everEdited,
          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.doConfirmEdit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])), [
        [_directive_loading, _ctx.loadings.formLoading]
      ])
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.combineId) + " ", 1),
      (!_ctx.loadings.formLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.isCombine)
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  model: _ctx.formEditAlbum,
                  "status-icon": "",
                  "label-width": "80px"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_form_item, { label: "专辑名" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formEditAlbum.title,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEditAlbum.title) = $event)),
                                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form_edited()))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "年份" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formEditAlbum.year,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEditAlbum.year) = $event)),
                                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form_edited()))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (_ctx.id)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "专辑名-罗马字"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.formEditAlbum.title_roman,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formEditAlbum.title_roman) = $event)),
                                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form_edited()))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.id)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    label: "专辑名-简体中文"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.formEditAlbum.title_cn_simp,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formEditAlbum.title_cn_simp) = $event)),
                                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form_edited()))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, { label: "长度" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EnumEditor, {
                                    modelValue: _ctx.formEditAlbum.type,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formEditAlbum.type) = $event)),
                                    enums: {
                                                '0': '未知',
                                                '1': '全长',
                                                '2': '单曲',
                                                '3': '短专',
                                            },
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.form_edited()))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "类型" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EnumEditor, {
                                    modelValue: _ctx.formEditAlbum.album_type,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formEditAlbum.album_type) = $event)),
                                    enums: {
                                                '0': '录音室专辑',
                                                '1': '合集',
                                                '2': '原声',
                                                '6': '现场',
                                                '7': 'Remix',
                                                '8': 'DJ-Remix',
                                                '10': 'Demo',
                                                '20': '其他',
                                            },
                                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.form_edited()))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.formEditAlbum.main_artist_show) + " ", 1),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formEditAlbum.main_artist.name), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formEditAlbum.main_artist._id,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formEditAlbum.main_artist._id) = $event)),
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeMainArtist()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditAlbum.artists, (ar, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: ar._id,
                            class: "album-name mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", null, _toDisplayString(ar.name), 1),
                              _createElementVNode("span", {
                                class: "btn-mini",
                                onClick: ($event: any) => (_ctx.removeArtistsIndex(index))
                              }, "x", 8, _hoisted_14)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.addArtistId,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addArtistId) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("span", {
                            class: "btn-mini",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addArtists()))
                          }, "+")
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditAlbum.links, (link) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: link.url
                          }, [
                            _createElementVNode("a", {
                              href: link.url,
                              target: "_blank"
                            }, [
                              _createElementVNode("b", null, "[ " + _toDisplayString(link.site) + " ]", 1)
                            ], 8, _hoisted_16)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", null, [
                        _createVNode(_component_StyleInput, {
                          multiple: true,
                          styles: _ctx.formEditAlbum.styles,
                          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onChooseStyle($event)))
                        }, null, 8, ["styles"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", null, [
                        _createVNode(_component_StyleInput, {
                          multiple: true,
                          styles: _ctx.formEditAlbum.relate_styles,
                          onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.choose_relate_style($event)))
                        }, null, 8, ["styles"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formEditAlbum.online_links, (link, index) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            key: index,
                            label: _ctx.online_link_name[index]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formEditAlbum.online_links[index].url,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.formEditAlbum.online_links[index].url) = $event),
                                onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.change_online_link()))
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createElementVNode("img", {
                        class: "img-fluid",
                        src: _ctx.formEditAlbum.primary_img
                      }, null, 8, _hoisted_26),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formEditAlbum.primary_img) = $event)),
                        class: "form-control",
                        onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.form_edited && _ctx.form_edited(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.formEditAlbum.primary_img]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCombine == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", null, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.combineId,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.combineId) = $event)),
                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.form_edited()))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCombine == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_EnumEditor, {
                  modelValue: _ctx.combineIdFrom,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.combineIdFrom) = $event)),
                  enums: {
                            release: 'discogs release',
                            master: 'discogs master',
                            netease: '网易云',
                        },
                  class: "mr-3",
                  onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.form_edited()))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.combineId,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.combineId) = $event)),
                  onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.url_form_edited()))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"])), [
    [_directive_loading, _ctx.loadings.formLoading]
  ])
}